// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlays_overlay__3-JtQ","overlay__title":"overlays_overlay__title__MwAxj","overlay__subtitle":"overlays_overlay__subtitle__18fSR"};